import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private maintenanceSubject = new BehaviorSubject<boolean>(false);
  private maintenanceType = new BehaviorSubject<String>("");
  readonly isMaintenance$ = this.maintenanceSubject.asObservable();
  readonly maintenanceType$ = this.maintenanceType.asObservable();

  enableMaintenance(type: string): void {
    this.maintenanceSubject.next(true);
    this.maintenanceType.next(type);
  }

  disableMaintenance(): void {
    this.maintenanceSubject.next(false);
  }
}